import dayjs from 'dayjs';
import type { CartGetters } from './types';

export function useCartGetters(): CartGetters {
  // Getters Cart

  const getCartId = (cart: GetCartResponse): string => cart.id;

  const getCartName = (cart: GetCartResponse): string => cart.name;

  const getCartCreationDate = (cart: GetCartResponse): string =>
    dayjs(cart.creationDate).format('DD-MM-YYYY');

  const getCartType = (cart: GetCartResponse): string => cart.type;

  const getCartStatus = (cart: GetCartResponse): string => cart.status;

  const getNumberOfProducts = (cart: GetCartResponse): number => cart.numberOfProducts;

  const getNumberOfLines = (cart: GetCartResponse): number => cart.numberOfLines;

  const getCartCurrency = (cart: GetCartResponse): string => cart.currency;

  const getTotalPriceWithTax = (cart: GetCartResponse): number => cart.totalPrice.priceWithTax;

  const getTotalPriceWithoutTax = (cart: GetCartResponse): number =>
    cart.totalPrice.priceWithoutTax;

  const getTotalTaxAmount = (cart: GetCartResponse): number => cart.totalPrice.taxAmount;

  const getTotalDiscountPriceWithTax = (cart: GetCartResponse): number =>
    cart.totalDiscountPrice.priceWithTax;

  const getTotalDiscountTaxAmount = (cart: GetCartResponse): number =>
    cart.totalDiscountPrice.taxAmount;

  // Getters Cart Lines
  const getCartProductQuantity = (cartLine: CartLine): number => cartLine.quantity;

  const getCartProductCreatedAt = (cartLine: CartLine): string => cartLine.createdAt;

  const getCartProductUpdatedAt = (cartLine: CartLine): string => cartLine.updatedAt;

  // should export in sdk model BlockedLineInformation
  // const getCartBlockedLineInformation = (
  //   cartLine: CartLine
  // ): BlockedLineInformation | undefined => cartLine.blockedLineInformation;

  const getCartProductVariantId = (cartLine: CartLine): string | undefined =>
    cartLine.productVariant?.id;

  const getCartProductVariantName = (cartLine: CartLine): string | undefined =>
    cartLine.productVariant?.name;

  const getCartProductVariantMpn = (cartLine: CartLine): string | undefined =>
    cartLine.productVariant?.mpn;

  const getCartProductVariantImageLink = (cartLine: CartLine): string | undefined =>
    cartLine.productVariant?.imageLink;

  const getCartProductVariantSku = (cartLine: CartLine): string | undefined =>
    cartLine.productVariant?.skuVariant;

  const getCartProductSku = (cartLine: CartLine): string | undefined =>
    cartLine.productVariant?.skuProduct;

  const getCartProductVariantBrand = (cartLine: CartLine): string | undefined =>
    cartLine.productVariant?.brand;

  const getCartProductVariantSkuProduct = (cartLine: CartLine): string | undefined =>
    cartLine.productVariant?.skuProduct;

  const getCartProductVariantStatus = (cartLine: CartLine): string | undefined =>
    cartLine.productVariant?.status;

  const getCartSupplierId = (cartLine: CartLine): string | undefined => cartLine.supplier?.id;

  const getCartSupplierName = (cartLine: CartLine): string | undefined => cartLine.supplier?.name;

  const getCartSupplierStatus = (cartLine: CartLine): string | undefined =>
    cartLine.supplier?.status;

  const getCartOfferId = (cartLine: CartLine): string | undefined => cartLine.offer?.offerPriceId;

  const getCartOfferCurrency = (cartLine: CartLine): string | undefined => cartLine.offer?.currency;

  const getCartOfferPriceWithoutTax = (cartLine: CartLine): number | undefined =>
    cartLine.offer?.totalPrice?.priceWithoutTax;

  const getCartOfferPriceWithTax = (cartLine: CartLine): number | undefined =>
    cartLine.offer?.totalPrice?.priceWithTax;

  const getCartOfferTaxAmount = (cartLine: CartLine): number | undefined =>
    cartLine.offer?.totalPrice?.taxAmount;

  const getCartOfferDiscountPriceWithoutTax = (cartLine: CartLine): number | undefined =>
    cartLine.offer?.totalDiscountPrice?.priceWithoutTax;

  const getCartOfferDiscountPriceWithTax = (cartLine: CartLine): number | undefined =>
    cartLine.offer?.totalDiscountPrice?.priceWithTax;

  const getCartOfferStock = (cartLine: CartLine): number | undefined => cartLine.offer?.stock;

  const getCartOfferItemPerPack = (cartLine: CartLine): number | undefined =>
    cartLine.offer?.itemPerPack;

  const getCartOfferMinOrderQuantity = (cartLine: CartLine): number | undefined =>
    cartLine.offer?.minOrderQuantity;

  const getCartOfferMaxOrderQuantity = (cartLine: CartLine): number | undefined =>
    cartLine.offer?.maxOrderQuantity;

  const getCartOfferPackingType = (cartLine: CartLine): string | undefined =>
    cartLine.offer?.packingType;

  const getCartOfferProductUnit = (cartLine: CartLine): string | undefined =>
    cartLine.offer?.productUnit;

  const getCartOfferNavigationCategory = (cartLine: CartLine): string | undefined =>
    cartLine.offer?.navigationCategory;

  const getCartOfferStatus = (cartLine: CartLine): string | undefined => cartLine.offer?.status;

  return {
    // Cart getters
    getCartId,
    getCartName,
    getCartCreationDate,
    getCartType,
    getCartStatus,
    getNumberOfProducts,
    getNumberOfLines,
    getCartCurrency,
    getTotalPriceWithTax,
    getTotalPriceWithoutTax,
    getTotalTaxAmount,
    getTotalDiscountPriceWithTax,
    getTotalDiscountTaxAmount,

    // Cart line getters
    getCartProductQuantity,
    getCartProductVariantSkuProduct,
    getCartProductVariantImageLink,
    getCartProductCreatedAt,
    getCartProductUpdatedAt,
    getCartProductVariantId,
    getCartProductVariantName,
    getCartProductVariantSku,
    getCartProductSku,
    getCartProductVariantBrand,
    getCartProductVariantMpn,
    getCartProductVariantStatus,
    getCartSupplierId,
    getCartSupplierName,
    getCartSupplierStatus,
    getCartOfferId,
    getCartOfferCurrency,
    getCartOfferPriceWithoutTax,
    getCartOfferPriceWithTax,
    getCartOfferTaxAmount,
    getCartOfferDiscountPriceWithoutTax,
    getCartOfferDiscountPriceWithTax,
    getCartOfferStock,
    getCartOfferItemPerPack,
    getCartOfferMinOrderQuantity,
    getCartOfferMaxOrderQuantity,
    getCartOfferPackingType,
    getCartOfferProductUnit,
    getCartOfferNavigationCategory,
    getCartOfferStatus,
  };
}
